import React from 'react'
import { csx } from '@vtex/admin-ui'

import type { OrderFormItemWithAssemblyItems } from '../../screens/Cart/typings'
import { DetailedProductsListItem } from '../DetailedProductsList'
import { getCartItemReactKey } from '../../utils'

type CartSummaryItemsProps = {
  item: OrderFormItemWithAssemblyItems
}

export const CartSummaryItems = ({
  item: {
    orderFormItem: { item, index },
    assemblyItems,
  },
}: CartSummaryItemsProps) => {
  return (
    <div
      key={getCartItemReactKey(item.id, index)}
      className={csx({
        ':not(:last-child)': {
          borderBottom: '$neutral',
          paddingBottom: '$space-6',
          marginBottom: '$space-6',
        },
      })}
    >
      <DetailedProductsListItem item={item} />
      {assemblyItems?.map((assemblyItem) => (
        <div
          key={getCartItemReactKey(assemblyItem.item.id, assemblyItem.index)}
          className={csx({ paddingTop: '$space-6' })}
        >
          <DetailedProductsListItem item={assemblyItem.item} />
        </div>
      ))}
    </div>
  )
}
